import { gql } from 'graphql-tag';

export const getClipartCategories = gql`
  query getClipartCategories($page: Int!, $perPages: Int!) {
    categories(item_type: CLIPART, page: $page, per_page: $perPages) {
      name
      id
    }
  }
`;

export const getClipArts = gql`
  query getClipArts($categoryId: ID!, $page: Int, $perPages: Int) {
    cliparts(category_id: $categoryId, page: $page, per_page: $perPages) {
      id
      name
      category
      thumbnail
      large_url
    }
  }
`;

export const searchClipArt = gql`
  query searchClipArt($keyword: String!) {
    category_keyword(keyword: $keyword) {
      id
      cliparts {
        id
        name
        category
        thumbnail
        large_url
      }
    }
  }
`;
